import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Instagram, MessageCircle } from "lucide-react";
import { SITE } from "@/data/site";
import { SERVICES } from "@/data/services";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 border-t-4 border-cyan-600"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand column */}
          <div className="md:col-span-4">
            <div className="bg-white p-4 inline-block rounded-sm mb-4">
              <img
                src="/logo.png?v=2"
                alt="DATAVIB"
                className="h-12 sm:h-14 w-auto object-contain"
                loading="lazy"
              />
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-cyan-400 font-mono-accent mb-4">
              {SITE.tagline}
            </div>
            <p className="text-sm leading-relaxed text-slate-400 max-w-sm">
              Titreşim analizi, yerinde balans, hizalama, fan & pompa revizyonu ve
              endüstriyel otomasyon — kestirimci bakımda tek noktadan çözüm
              ortağınız. Saha ekibimiz ve ihtiyaca göre çözüm ağımızla
              fabrikalarınıza uçtan uca destek sunuyoruz.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={SITE.social.linkedin}
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
                className="w-9 h-9 grid place-items-center border border-slate-700 hover:border-cyan-500 hover:text-cyan-400 transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href={SITE.social.instagram}
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-9 h-9 grid place-items-center border border-slate-700 hover:border-cyan-500 hover:text-cyan-400 transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services list */}
          <div className="md:col-span-4">
            <div className="text-xs font-mono-accent text-cyan-400 tracking-[0.22em] uppercase mb-4">
              Hizmetler
            </div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/hizmetler/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-slate-300 hover:text-cyan-400 transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-xs font-mono-accent text-cyan-400 tracking-[0.22em] uppercase mb-4">
              İletişim
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-cyan-400" />
                <a href={SITE.phoneHref} className="hover:text-cyan-400">{SITE.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-cyan-400" />
                <a href={SITE.emailHref} className="hover:text-cyan-400">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-cyan-400" />
                <span>{SITE.address}</span>
              </li>
              <li>
                <a
                  href={SITE.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-whatsapp"
                  className="btn-whatsapp text-sm mt-2"
                >
                  <MessageCircle className="w-4 h-4" /> WhatsApp'tan Yaz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row sm:justify-between gap-3 text-xs text-slate-500">
          <span>© {year} {SITE.brand}. Tüm hakları saklıdır.</span>
          <span className="font-mono-accent">v1.0 · Industrial Maintenance Services</span>
        </div>
      </div>
    </footer>
  );
}
